import { EventEmitter } from '../../util/eventemitter';

export class MoCommand extends EventEmitter {
    object: any;
    isComplete: boolean;
    wantInterrupt: boolean;

    constructor(object: any) {
        super();
      this.object = object;
      this.isComplete = false;
      this.wantInterrupt = false;
    }

    _enter() {
      this.emit('enter');
      this.enter();
    }

    _leave() {
      this.leave();
      this.emit('leave');
    }

    enter() {
    }

    leave() {
    }

}







